document.addEventListener('DOMContentLoaded', function() {
    var faqWrappers = document.querySelectorAll('.faq-wrapper-desktop');

    faqWrappers.forEach(function(faqWrapper) {
        var questions = faqWrapper.querySelectorAll('.question');
        var answers = faqWrapper.querySelectorAll('.answer');

        if (questions.length > 0 && answers.length > 0) {
            questions[0].classList.add("active");
            answers[0].classList.add("active");
        }

        function selectAnswer(index) {
            questions.forEach(function(question) {
                question.classList.remove("active");
            });

            answers.forEach(function(answer) {
                answer.classList.remove("active");
            });

            questions[index].classList.add('active');
            answers[index].classList.add('active');
        }

        questions.forEach(function(question, index) {
            question.addEventListener('click', function() {
                selectAnswer(index);
            });
        });
    });
});

function openAnswer(element) {
    element.classList.toggle('active');
    element.nextElementSibling.classList.toggle('active');
}  